<template>
  <v-content>
    <v-container
    >
      <v-layout 
        align-center 
        justify-center>
        <v-flex xs12
          sm4
          align-center >
          <img
            src="/img/logo-login.png"
            class="logo"
          />       
        </v-flex>
      </v-layout>
      <v-layout
        flex
        align-center
        justify-center
      >
        <v-flex
          xs12
          sm5
        >
          <v-card class="login-box">
            <v-card-text class="pt-4">
              <v-toolbar-title >
                <h2>Account Activation</h2>
                <h5>Confirm to activate</h5>
              </v-toolbar-title>
              <div>
                <v-form ref="observer" tag="form" @submit.prevent="validateAccount">
                  <v-layout
                    justify-space-between
                    class="mt-2"
                  >
                    <v-btn type="submit" outlined color="primary">Confirm</v-btn>
                  </v-layout>
                  <!-- v-layout wrapper-button class="mt-2">
                    <v-btn text :to="{name : 'forgot-password'}">
                      Reset your password
                    </v-btn>
                  </v-layout -->
                </v-form>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import AppConfig from '@/config/appConfig'
import storageUtil from '@/helpers/storage'

export default {
  data () {
    return {
      form: {
        guid: this.$route.params.token,
        email: this.$route.params.email,
        app:'ayres_core'
      },
      appLogo: AppConfig.appLogo2
    }
  },
  methods: {
    validateAccount () {      
      const vm = this
      vm.$store.dispatch('activateAccount', {
        credentials: vm.form
      })
    }
  }

}
</script>
<style scoped>
  .v-toolbar__title {
    width: 100%;
  }
  h2 {
    font-weight: 600;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    text-align: left;
    color: black;
  }
  
  h5 {
    font-weight: 400;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    text-align: left;
    color: black;
  }
  .login-box {
    border: 2px solid #244AB3;
    border-radius: 10% !important;
    min-height: 250px;
    min-width: 450px;
  }
  .logo {
    left: 40px;
  }
  .btn-login {
    background-color: #244AB3 !important;
    border-color: #244AB3 !important;
    border-radius: 45px;
    min-height: 48px;
    color: #244AB3;
  }
  .v-btn{
    text-transform: none !important;
  }
  .pt-4 {
    padding-top: 40px !important;
  }
  .wrapper-button {
    display: -webkit-box;
  }
  .v-btn {
    margin: 0 auto;
    display: flex;
  }
  </style>
  